import { BigNum, PRICE_PRECISION_EXP } from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { memo } from 'react';
import useVelocityStore from '../../stores/VelocityStore/useVelocityStore';
import { PriceChangePercentDisplay } from './PriceChangePercentDisplay';
import DefinitionTooltip from 'src/components/Tooltip/DefinitionTooltip/DefinitionTooltip';
import { getMarketPriceDecimals } from 'src/constants/marketDecimalConfig';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import NumberDisplay from '../NumberDisplay/NumberDisplay';
import { cm } from 'src/utils/classNames';
import { PRESETS, withDecimals } from 'src/utils/formatNumber/presets';

interface Props {
	loading: boolean;
	price: string;
	className?: string;
	marketId?: MarketId;
}

function MarkPriceDisplay({ loading, price, className, marketId }: Props) {
	const isMobileScreenSize = useIsMobileScreenSize();

	const currentMarket = useVelocityStore((s) => s.selectedMarket.current);
	const marketSymbol = currentMarket?.uiSymbols.baseAssetSymbol ?? '';
	const priceDecimals = getMarketPriceDecimals(marketSymbol);

	const markPrice = price
		? BigNum.from(price, PRICE_PRECISION_EXP)
		: BigNum.zero();

	return (
		<DefinitionTooltip
			decoration="cursor-help"
			definitionId="tradingMarkPrice"
			disabled={isMobileScreenSize}
		>
			<div className={cm('flex flex-col items-start gap-2xs', className)}>
				{/* Large price display */}
				<NumberDisplay
					value={markPrice}
					options={withDecimals(PRESETS.usdTruncate, priceDecimals)}
					loading={loading}
					skeletonClassName="w-24 h-2xl"
					className="typo-heading-h5 text-text-default sm:typo-label-lg"
				/>

				{/* Percentage change below */}
				{marketId && (
					<PriceChangePercentDisplay
						marketId={marketId}
						markPrice={markPrice}
						className="typo-body-sm"
					/>
				)}
			</div>
		</DefinitionTooltip>
	);
}

export default memo(MarkPriceDisplay);
